import AOS from "aos"
const REVIEW_SELECTOR = '[data-bv-show="reviews"]';
const REVIEW_MAIN_CONTAINER_SELECTOR = '#bv_review_maincontainer';
import DynamicSectionElement from "../../frontend/scripts/dynamic-section-element"


class BvReviews extends DynamicSectionElement {
  constructor() {
    super()

    this.sectionId = this.dataset.sectionId

    let showSection = false
    const userInteractionEvents = ["scroll", "mousedown", "mousemove", "click", "keydown", "touchstart"]
    userInteractionEvents.forEach(event => {
      window.addEventListener(event, () => {
        if (!showSection) {
          showSection = true
          this.loadSectionFromUrl(window.location.pathname + '?view=ajax')
          this.reviewsInit()
        }
      }, { passive: true })
    })

    if (document.body.getBoundingClientRect() && (document.body.getBoundingClientRect().y !== 0)) {
      showSection = true
      this.loadSectionFromUrl(window.location.pathname + '?view=ajax')
      this.reviewsInit()
    }
  }

  get name() {
    return this.sectionId
  }

  reviewsInit() {
    const targetNode = document.body;
    const reviewEl = document.querySelector(REVIEW_SELECTOR)
    let addBVRRSearchContainer = false
    let addedHeader = false
    let addedContent = false
    let showReviews = false

    const config = { attributes: true, childList: true, subtree: true };
    let appendStyles = false

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {

          if (!addBVRRSearchContainer) {
            const BVRRSearchContainer = document.querySelector('#BVRRSearchContainer')
            if (BVRRSearchContainer) {
              BVRRSearchContainer.setAttribute('data-aos', 'fade-up')
              AOS.refreshHard()
              addBVRRSearchContainer = true
            }
          }

          if (!addedHeader) {
            const headerEl = document.querySelector('.bv-header')
            if (headerEl) {
              headerEl.setAttribute('data-aos', 'fade-up')
              AOS.refreshHard()
              addedHeader = true
            }
          }

          if (!addedContent) {
            const contentEl = document.querySelectorAll('.bv-content-item')
            if (contentEl.length > 0) {
              contentEl.forEach(item => {
                item.setAttribute('data-aos', 'fade-up')
              })
              AOS.refreshHard()
              addedContent = true
            }
          }

          const modalEl = document.querySelector('#bv-mboxzone-lightbox')
          if (modalEl) {
            targetNode.classList.add('modal-review-open')
          } else {
            targetNode.classList.remove('modal-review-open')
          }

          const reviewsText = document.querySelectorAll('.bv_numReviews_component_container .bv_text')
          if (reviewsText.length > 0) {
            reviewsText.forEach(item => {
              const text = item.textContent.trim()
              if (text && !text.includes('Reviews')) {
                item.textContent = text.replace(/\)$/, '') + ' Reviews)'
              }
            })
          }

          const firstReviewBtnEl = document.querySelector('#first-to-write')
          if (firstReviewBtnEl) {
            firstReviewBtnEl.closest('#bv-reviews').classList.add('bv-reviews--empty')
          }

          if (!showReviews) {
            const reviewEl = document.querySelector('[data-bv-show="reviews"]')
            if (reviewEl) {
              const reviewsList = reviewEl.shadowRoot?.querySelector('#reviews_container')
              if (reviewsList) {
                const reviewTitles = reviewsList.querySelectorAll('h3')
                const helpFullEls = reviewsList.querySelectorAll('.bv-feedback-container > [role="group"]')

                if (reviewTitles.length > 0 && helpFullEls.length > 0 && reviewTitles.length === helpFullEls.length) {
                  helpFullEls.forEach((el, index) => {
                    const title = reviewTitles[index]?.innerText.trim()
                    if (el && title) {
                      el.setAttribute('aria-label', `Content helpfulness, ${title}`)
                    }
                  })
                  showReviews = true
                }
              }
            }
          }

          if (reviewEl && reviewEl?.shadowRoot) {
            const reviewMainContainerEl = reviewEl?.shadowRoot.querySelector(REVIEW_MAIN_CONTAINER_SELECTOR)
            if (reviewMainContainerEl && !appendStyles) {
              const styleEl = document.createElement('style')
              styleEl.innerHTML = `
                .bv_rating_content2 .bv-rnr__sc-157rd1w-2.bPZJVP {
                  color: #E75220 !important;
                  font-weight: 700 !important;
                }

                .reportbutton,
                .uDUhU {
                  color: #DE300D !important;
                }

                .bv_rating_content2 button {
                  color: #DE300D !important;
                }
              `
              reviewEl.shadowRoot.appendChild(styleEl)
              appendStyles = true
            }
          }
        }
      }
    }

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);

  }
}

if (!customElements.get('bv-reviews')) {
  customElements.define('bv-reviews', BvReviews)
}
